import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[(_vm.loader)?_c('div',[_c(VProgressLinear,{attrs:{"indeterminate":"","color":"green"}})],1):_c('div',[(_vm.List.length)?_c('div',_vm._l((_vm.List),function(item,idx){return _c('div',{key:idx,staticClass:"text-body-2 events__list"},[_c(VIcon,{staticClass:"mr-3",attrs:{"size":"30","color":"#c69494"}},[_vm._v(" mdi-circle-small ")]),_vm._v(" "+_vm._s(item.text)+" ")],1)}),0):_c('div',[_vm._v("Нет данных")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }